function MobileView() {
  return null
}

export default MobileView;
